import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { articlesApi } from '../lib/api';
import PeptiQPopup from './PeptiQPopup';

/**
 * Route-aware gate that mounts the PeptiQ popup ONLY on peptide-related pages:
 *   1. /peptides hub (any sub-route)
 *   2. /blogs/article/:slug when article.category === 'Peptides'
 *
 * Mounting is centralized here so neither PeptidesHubPage nor the 1854-line
 * ArticlePage needs to be touched.
 */
export default function PeptiQPopupGate() {
  const location = useLocation();
  const [eligible, setEligible] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setEligible(false);

    const path = location.pathname;

    // Direct hub match
    if (path === '/peptides' || path.startsWith('/peptides/')) {
      setEligible(true);
      return;
    }

    // Article match: only enable if the loaded article is categorized 'Peptides'
    const articleMatch = path.match(/^\/blogs\/article\/([^/]+)\/?$/);
    if (articleMatch) {
      const slug = articleMatch[1];
      articlesApi.getBySlug(slug)
        .then((res) => {
          if (cancelled) return;
          const cat = (res.data?.category || '').toLowerCase();
          if (cat === 'peptides') setEligible(true);
        })
        .catch(() => { /* silent */ });
    }

    return () => { cancelled = true; };
  }, [location.pathname]);

  if (!eligible) return null;
  // Remount on route change so per-page session throttling is honored
  return <PeptiQPopup key={location.pathname} />;
}
